<p>{{'NEW_TASK_WAS_CREATED' | translate}}</p>
<p>{{'DATE' | translate}}: {{data.date}}</p>
<p>{{'LINK' | translate}}: <a [href]="data.link">{{data.link}}</a></p>
